angular
	.module 'App.Directive'
	.directive 'wmInfiniteScroll', ($document) ->
		restrict: 'A'
		scope:
			fnBottomReached: '&wmInfiniteScroll'
			disabled: '@?'
			delay: '=?' # Delay between heigh checks. Default 300
			distance: '=?' # Margin from bottom of element to trigger function call. Default 50
		link: (scope, element) ->
			timer = null
			delay = if angular.isDefined(scope.delay) then parseInt(scope.delay) else 300

			element
				.bind(
					"scroll",
					->
						clearTimeout timer

						if not scope.disabled
							timer = setTimeout(
								->
									distance = if angular.isDefined(scope.distance) then parseInt(scope.distance) else 50

									if element[0].scrollTop + element[0].offsetHeight >= element[0].scrollHeight - distance
										#run the event that was passed through
										scope.$apply(scope.fnBottomReached)
								,
								delay
							)
				)
